module.exports = __webpack_public_path__ + "img/d6.ff32b197.jpg";